/* eslint-disable @next/next/no-img-element */
import Link from 'next/link';
import Router, { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

//Component
import { MainItem } from './DropdownItem';
import ItemContainer from './ItemContainer';
import MobileMenu from './MobileMenu';

// utils
import { lereroFetch } from 'utils/fetch';
import { synchronizedSingleCartData } from 'utils/manipulate_array';
import { generateCoverImageUrl } from 'utils/generate_cover_image_url';

import { truncateText } from 'utils/helper';
import { useWhitelabelContext } from 'context/whitelabel.context';
import CourseCategories from './CourseCategories';
import Provider from './Provider';
import SearchBar from './SearchBar';
import { isDefaultUrl } from 'utils/is_default_url';
import { BLOCKED_PROVIDERS } from 'variables/filter';
import { trackNavClick } from 'lib/analytics';

export default function Navbar() {
  const router = useRouter();
  const { header, lookAndFeel } = useWhitelabelContext();
  const currentPath = window.location.origin;
  const isMentae = currentPath.includes('maentae');
  const isLmsl = currentPath.includes('lmsl');
  const isTKI = currentPath.includes('tki');
  const isFaei = currentPath.includes('faei');

  const [categories, setCategories] = useState([]);
  const [provider, setProvider] = useState([]);
  const [toggle, setToggle] = useState('');

  const [cartTotal, setCartTotal] = useState(0);
  const [cart, setCart] = useState([]);
  const [isSearchBarOpened, setIsSearchBarOpened] = useState(false);
  const [isMenuOpened, setIsMenuOpened] = useState(false);
  const [openedChild, setOpenedChild] = useState('');
  const [openedChildDesktop, setOpenedChildDesktop] = useState('');
  const [logoLink, setLogoLink] = useState('https://lerero.com');

  useEffect(() => {
    const hostname = window?.location?.hostname || '';

    const subdomainLinks = {
      maentae: 'https://maentae.com/',
      faei: 'https://faei.org/',
      lmsl: 'https://lifemanagementsciencelabs.com/',
    };

    for (const key in subdomainLinks) {
      if (hostname.includes(key)) {
        setLogoLink(subdomainLinks[key]);
        break;
      }
    }
  }, []);

  // When user is in cart page, do not show the detail of the cart. This will be applied only in mobile view.
  useEffect(() => {
    if (router.pathname === '/cart') {
    }
  }, [router]);

  const handleLoadCourseCategories = async () => {
    const response = await lereroFetch('GET', `/categories/dropdown`);
    if (response.success) {
      setCategories(response.data);
    }
  };

  const handleLoadMenuProvider = async () => {
    const response = await lereroFetch('GET', `/items/list/providers`);
    if (response.success) {
      const filteredProviders = response.data
        .filter((p) => !BLOCKED_PROVIDERS.includes(p.name.trim()))
        .sort((a, b) => a.name.localeCompare(b.name));

      setProvider(filteredProviders);
    }
  };

  const handleCheckout = () => {
    // when click checkout, redirect to cart page with all items in cart page is checked
    let cart = JSON.parse(localStorage.getItem('cart')) || [];
    let localStorageArray = [];
    cart.forEach((item) => {
      let json = synchronizedSingleCartData({ item: item, isProduct: item.isProduct ?? false });
      localStorageArray.push(json);
    });

    localStorage.setItem('is-cart-checked-all', JSON.stringify(true));
    localStorage.setItem('cart-checked', JSON.stringify(localStorageArray));
    trackNavClick({
      page_type: 'cart',
      nav_item: 'cart',
      location: 'header',
    });
    Router.push('/cart');
  };

  useEffect(() => {
    handleLoadCourseCategories();
    handleLoadMenuProvider();
  }, []);

  useEffect(() => {
    let _cart = [];
    if (localStorage.getItem('cart')) {
      _cart = JSON.parse(localStorage.getItem('cart'));
    }

    const synchronizedCartData = _cart.map((item) => {
      return synchronizedSingleCartData({ item: item, isProduct: item.isProduct || false });
    });

    setCart(synchronizedCartData);
    setCartTotal(synchronizedCartData.length);
  }, [router.pathname]);

  return (
    <div className={`nav-wrapper ${isSearchBarOpened ? 'search-bar-opened' : ''}`}>
      <div className="menu-logo d-flex d-lg-none">
        <img className="menu" src="/navbar/menu.svg" alt="menu" onClick={() => setIsMenuOpened(true)} />
      </div>
      <div className="nav-menu nav-menu-left justify-content-lg-start justify-content-center w-lg-25">
        {/* Logo Section */}
        <div className="nav-logo">
          <Link href={logoLink} passHref={true}>
            <a target="_blank">
              <img
                className="logo d-lg-flex"
                src={lookAndFeel.logo || '/navbar/lerero_logo_new_2.svg'}
                alt="logo"
                style={{ width: '205px', height: '69px', objectFit: 'contain' }}
              />
            </a>
          </Link>
        </div>

        {!isLmsl && !isTKI && !isFaei && (
          <div className="d-lg-flex d-none">
            <ItemContainer setToggle={setToggle} identifier={'category'}>
              {header.enabledCourseCategory && (
                <MainItem toggle={toggle} name={'Select Category'} identifier={'category'}></MainItem>
              )}
              <CourseCategories
                show={toggle === 'category'}
                menu={categories}
                onReset={() => {
                  setToggle('');
                  setOpenedChildDesktop('');
                }}
                openedChild={openedChildDesktop}
                onOpenChild={setOpenedChildDesktop}
              />
            </ItemContainer>
          </div>
        )}


        <div className={!isDefaultUrl() ? 'd-none' : 'd-lg-flex d-none'}>
          <ItemContainer setToggle={setToggle} identifier={'providers'}>
            <MainItem name={'Providers'} toggle={toggle} identifier={'providers'}></MainItem>
            <Provider
              show={toggle === 'providers'}
              menu={provider}
              onReset={() => {
                setToggle('');
                setOpenedChildDesktop('');
              }}
            />
          </ItemContainer>
        </div>
      </div>

      <div className="nav-menu nav-menu-right w-100">
        <SearchBar onChangeCondition={(condition) => setIsSearchBarOpened(condition)} />

        {/* Cart Icon */}
        {/* onTouchEnd is fired when click the cart. When click the cart, do not show the detail of the cart so set it to false */}
        <div className="nav-menu__cart cursor-pointer" onClick={handleCheckout}>
          <font color="#0666f0" className="cart-logo">
            <i className="bi bi-cart2 d-lg-inline d-flex"></i>
          </font>
          {cartTotal !== 0 ? (
            <button className="cart-bubble" onClick={handleCheckout}>
              {cartTotal}
            </button>
          ) : (
            ''
          )}
        </div>
      </div>

      {/* Menu in Mobile */}
      <MobileMenu
        menu={categories}
        provider={provider}
        isMenuOpened={isMenuOpened}
        setIsMenuOpened={setIsMenuOpened}
        openedChild={openedChild}
        setOpenedChild={setOpenedChild}
        toggle={toggle}
        setToggle={setToggle}
      />
    </div>
  );
}
